// src/pages/RadiantIsleRH.js
import React from "react";
import GameMap from "./logic/GameMap";
import { mapConfigs } from "./MapConfig/mapConfigs";

export default function RadiantIsleRH() {
  React.useEffect(() => {
    document.title = "East Radiant Island | Pokémon Radiance";
  }, []);

  return <GameMap config={mapConfigs.radiantIsleRH} />;
}
